import * as materials from "@lts/materials/legacy/legacy-lava";
export { materials };
export default materials;
